import {
    HubPersona,
    createDataActionFactory,
    Feature,
    hashFolderId,
    createThunk,
    ThunkDispatch,
    OwsError,
} from '../../../shared';
import { findPeopleWithRequestTracking } from '../../dataLayer/ows/findPeopleWithRequestTracking';
import { getGuid } from 'owa-guid';

const BATCH_SIZE = 100;

export const loadPersonasInSparseFolderCompletedAction = createDataActionFactory<
    {
        personas: HubPersona[];
        offset: number;
        totalCount: number;
        folderId: string;
        batchId: string;
    },
    { error: OwsError; folderId: string }
>(
    'LoadPersonasInSparseFolderCompletedAction',
    Feature.ContactManagement,
    action => ({
        folderId: hashFolderId(action.payload.folderId),
        offset: action.payload.offset,
        totalCount: action.payload.totalCount,
        count: action.payload.personas ? action.payload.personas.length : 0,
    }),
    action => ({
        folderId: hashFolderId(action.payload.folderId),
    })
);

const getPersonasInSparseFolderInternal = (
    folderId: string,
    offset: number = 0,
    limit: number = BATCH_SIZE
) =>
    createThunk('GetPersonasInSparseFolderInternal', (dispatch: ThunkDispatch) => {
        const batchId = getGuid();

        const findPeopleChain = (offset: number) => {
            return findPeopleWithRequestTracking(
                folderId,
                offset,
                limit,
                null /* sortingPath */,
                false /* isExemptFromCurrentRequestCheck */,
                true /* isSparseFolder */
            ).then(
                ({ offset, totalCount, personas }) => {
                    dispatch(
                        loadPersonasInSparseFolderCompletedAction.success({
                            folderId,
                            personas,
                            batchId,
                            totalCount,
                            offset,
                        })
                    );
                },
                error =>
                    dispatch(loadPersonasInSparseFolderCompletedAction.error({ error, folderId }))
            );
        };

        return findPeopleChain(offset);
    });

export const getPersonasInSparseFolder = (dispatch: ThunkDispatch) => (
    folderId: string,
    offset: number = 0,
    limit: number = BATCH_SIZE
) => dispatch(getPersonasInSparseFolderInternal(folderId, offset - (offset % limit), limit));
